export default __webpack_public_path__ + "static/media/Background_00137.d5f1955f.png";